import React from 'react'

const AppProjectWindow = ({ name, title, description, tech }) => {
    return (
        <div className="Project-App" data-aos="fade-up" data-aos-duration="1000">
            <div href="" className="Project--container-App" id="Project--container-App">
                {/* <img src={img} alt="" className="Project--img-App" /> */}
                <video controls className="d-block w-100" autoPlay muted>
                    <source src={`../IMG/${name}/${name}.mp4`} type="video/mp4" />
                </video>
            </div>
            <p className="Project--Name-App">{title}</p>
            <p className="Project--Tech-App">{description}</p>
            <div className='d-flex flex-wrap '>
                {tech.map((techItem, index) => (
                    <p key={index} className="Project--Tech-Box me-2">{techItem}</p>
                ))}
            </div>
        </div>
    )
}

export default AppProjectWindow;